import { getRelativeTimeStampRange } from 'app/shared/utils/date';
import { useCampaignService } from 'hooks/mailing/campaign';
import { useMailActionService } from 'hooks/mailaction';
import { useMailLogService } from 'hooks/maillog';
import React, { useEffect, useState } from 'react';
import { SlidingStatBar } from 'app/layouts/stats/sliding';
import { RelativeStatCard } from 'app/shared/cards/stat/relative';

export const CampaignStatBar = () => {
  const { fetchCampaigns } = useCampaignService();
  const { fetchMailLogs } = useMailLogService();
  const { fetchMailActions } = useMailActionService();
  const [stats, setStats] = useState([
    {
      label: 'Total Campaigns',
      main_value: 0,
      current_value: 0,
      previous_value: 0
    },
    {
      label: 'Total Emails Sent',
      main_value: 0,
      current_value: 0,
      previous_value: 0
    },
    {
      label: 'Total Emails Opens',
      main_value: 0,
      current_value: 0,
      previous_value: 0
    },
    {
      label: 'Total Link Clicks',
      main_value: 0,
      current_value: 0,
      previous_value: 0
    }
  ]);

  useEffect(() => {
    const { this_month, last_month } = getRelativeTimeStampRange();
    Promise.all([
      fetchCampaigns({ query_string: `status=processed&count=1&bool=-is_test_campaign` }),
      fetchCampaigns({
        query_string: `time_stamp=${this_month.start}~${this_month.end}&status=processed&count=1&bool=-is_test_campaign`
      }),
      fetchCampaigns({
        query_string: `time_stamp=${last_month.start}~${last_month.end}&status=processed&count=1&bool=-is_test_campaign`
      }),
      fetchMailLogs({
        query_string: `class=campaign&count=1`
      }),
      fetchMailLogs({
        query_string: `time_stamp=${this_month.start}~${this_month.end}&class=campaign&count=1`
      }),
      fetchMailLogs({
        query_string: `time_stamp=${last_month.start}~${last_month.end}&class=campaign&count=1`
      }),
      fetchMailActions({
        query_string: `resource_type=campaign&action=opened&count=1`
      }),
      fetchMailActions({
        query_string: `time_stamp=${this_month.start}~${this_month.end}&resource_type=campaign&action=opened&count=1`
      }),
      fetchMailActions({
        query_string: `time_stamp=${last_month.start}~${last_month.end}&resource_type=campaign&action=opened&count=1`
      }),
      fetchMailActions({
        query_string: `resource_type=campaign&action=clicked_link&count=1`
      }),
      fetchMailActions({
        query_string: `time_stamp=${this_month.start}~${this_month.end}&resource_type=campaign&action=clicked_link&count=1`
      }),
      fetchMailActions({
        query_string: `time_stamp=${last_month.start}~${last_month.end}&resource_type=campaign&action=clicked_link&count=1`
      })
    ]).then(
      ([
        { size: all_campaigns },
        { size: this_month_campaigns },
        { size: last_month_campaigns },
        { size: all_mail_logs },
        { size: this_month_mail_logs },
        { size: last_month_mail_logs },
        { size: all_mail_opens },
        { size: this_month_mail_opens },
        { size: last_month_mail_opens },
        { size: all_link_clicks },
        { size: this_month_link_clicks },
        { size: last_month_link_clicks }
      ]) => {
        setStats([
          {
            label: 'Total Campaigns',
            main_value: all_campaigns,
            current_value: this_month_campaigns,
            previous_value: last_month_campaigns
          },
          {
            label: 'Total Emails Sent',
            main_value: all_mail_logs,
            current_value: this_month_mail_logs,
            previous_value: last_month_mail_logs
          },
          {
            label: 'Total Emails Opens',
            main_value: all_mail_opens,
            current_value: this_month_mail_opens,
            previous_value: last_month_mail_opens
          },
          {
            label: 'Total Link Clicks',
            main_value: all_link_clicks,
            current_value: this_month_link_clicks,
            previous_value: last_month_link_clicks
          }
        ]);
      }
    );
  }, []);

  return (
    <>
      <SlidingStatBar>
        {stats.map((stat, index) => (
          <RelativeStatCard
            key={index}
            title={stat.label}
            main_value={stat.main_value}
            current_value={stat.current_value}
            previous_value={stat.previous_value}
            period="month"
          />
        ))}
      </SlidingStatBar>
    </>
  );
};
